import * as React from 'react';
import {FormattedMessage} from '@meiko/react-intl';
import {useQuery} from '@tanstack/react-query';
import {getLeadEvents} from 'modules/marketingApp/marketingLeadPage/io';

import Panel from './Panel';
import LeadEventsTable from 'views/MarketingApp/MarketingLeadPage/components/LeadEventsTable';
import ContentEmpty from 'components/generic/ContentEmpty';

export default function LeadEventsPanel({lead}) {
	const {
		data: events,
		isLoading,
		isError,
	} = useQuery({
		queryKey: ['leadEvents', lead?.id],
		queryFn: () => getLeadEvents(lead?.id),
		enabled: !!lead?.id,
	});

	if (!lead?.id) {
		return null;
	}

	return (
		<Panel
			title={
				<>
					<FormattedMessage id="Events" /> ({lead.leadEvents?.data?.length})
				</>
			}
			initialOpen={false}
		>
			<div className="overflow-x-auto px-4 text-xs">
				{isError && <ContentEmpty message={<FormattedMessage id="Error" />} />}
				{isLoading && <ContentEmpty message={<FormattedMessage id="Loading" />} />}
				{events && <LeadEventsTable events={events} slimRows />}
			</div>
		</Panel>
	);
}
